// CartPage.js
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { FiTrash2, FiMinus, FiPlus, FiArrowRight, FiShoppingBag } from 'react-icons/fi';
import styles from './CartPage.module.css';

export default function CartPage() {
  const { items, removeItem, updateQty, subtotal, itemCount, clearCart } = useCart();
  const navigate = useNavigate();
  const shipping = subtotal >= 999 ? 0 : 60;
  const total = subtotal + shipping;

  if (items.length === 0) return (
    <div className={styles.empty}>
      <FiShoppingBag size={60} />
      <h2>Your cart is empty</h2>
      <p>Add some products to get started!</p>
      <Link to="/products" className="btn btn-primary btn-lg">Browse Products</Link>
    </div>
  );

  return (
    <div className="container" style={{ padding: '1.5rem 1rem' }}>
      <h1 className={styles.title}>Shopping Cart <span>({itemCount} items)</span></h1>
      <div className={styles.layout}>
        {/* Items */}
        <div className={styles.items}>
          {items.map(item => (
            <div key={`${item._id}-${item.variant}`} className={styles.item}>
              <img src={item.thumbnail} alt={item.name} className={styles.itemImg} />
              <div className={styles.itemInfo}>
                <Link to={`/products/${item.slug || item._id}`} className={styles.itemName}>{item.name}</Link>
                {item.variant && <p className={styles.itemVariant}>{item.variant}</p>}
                <p className={styles.itemPrice}>৳{(item.discountPrice || item.price).toLocaleString()}</p>
              </div>
              <div className={styles.qtyControl}>
                <button onClick={() => updateQty(item._id, item.variant, item.quantity - 1)}><FiMinus size={12}/></button>
                <span>{item.quantity}</span>
                <button onClick={() => updateQty(item._id, item.variant, item.quantity + 1)}><FiPlus size={12}/></button>
              </div>
              <p className={styles.lineTotal}>৳{((item.discountPrice || item.price) * item.quantity).toLocaleString()}</p>
              <button className={styles.removeBtn} onClick={() => removeItem(item._id, item.variant)}><FiTrash2 size={16}/></button>
            </div>
          ))}
          <button className="btn btn-ghost btn-sm" onClick={clearCart} style={{marginTop:'0.5rem'}}>Clear Cart</button>
        </div>

        {/* Summary */}
        <div className={styles.summary}>
          <h3>Order Summary</h3>
          <div className={styles.summaryRows}>
            <div className={styles.summaryRow}><span>Subtotal</span><span>৳{subtotal.toLocaleString()}</span></div>
            <div className={styles.summaryRow}>
              <span>Shipping</span>
              <span>{shipping === 0 ? <span style={{color:'var(--success)'}}>FREE</span> : `৳${shipping}`}</span>
            </div>
            {shipping === 0 && <p style={{fontSize:'0.75rem',color:'var(--success)'}}>🎉 Free delivery applied!</p>}
            {shipping > 0 && <p style={{fontSize:'0.75rem',color:'var(--text-muted)'}}>Add ৳{999-subtotal} more for free delivery</p>}
            <div className={styles.divider}/>
            <div className={`${styles.summaryRow} ${styles.totalRow}`}><span>Total</span><span>৳{total.toLocaleString()}</span></div>
          </div>
          <button className="btn btn-primary btn-lg btn-block" onClick={() => navigate('/checkout')}>
            Proceed to Checkout <FiArrowRight />
          </button>
          <Link to="/products" className="btn btn-ghost btn-block" style={{marginTop:'0.5rem'}}>Continue Shopping</Link>
        </div>
      </div>
    </div>
  );
}
